module.exports = __webpack_public_path__ + "media/images/icons/since-badge-de-d9d52df40a852a0627b2d03f64409019.svg";